
<template>
  <div class="additional-details">
    <md-tooltip
      class="additional-details__custom-tooltip"
      md-direction="top"
    >
      <h4>OUTROS NTOS:</h4>
      <ul>
        <template v-for="(nto, index) in NTOsLeft">
          <li :key="index">
            {{ nto.samplesCount }} amostra<span v-if="nto.samplesCount > 1">s</span> para {{ nto.placeExecution }}
          </li>
        </template>
      </ul>
    </md-tooltip>
    e mais {{ NTOsLeft.length }} NTO<span v-if="NTOsLeft.length > 1">s</span>...
  </div>
</template>

<script>
export default {
  name: 'ButtonWithIcon',
  props: {
    NTOsLeft: {
      type: Array,
      default: []
    }
  }
}
</script>
<style lang="scss">
.additional-details {
  font-size: 12px;
  color: #7a7a7a;
  cursor: help;

  &__custom-tooltip {
    ul {
      margin: 10px 15px;
    }
    ul li {
      list-style-type: circle;
      width: 420px;
      white-space: normal;
    }
    padding: 2%;
    font-size: 12px;
    width: 470px;
  }
}
</style>
